import { ImpactPartnerInfo } from '@platform/client/schemas';
import BusinessModelStrengtheningSvg from './svgs/business-model-strengthening.svg';
import HeroPrimaryImage from './svgs/hero-1.png';
import HeroSecondaryImage from './svgs/hero-2.jpg';
import NewConnectionsOpportunitiesSvg from './svgs/new-connections-opportunities.svg';
import NoCostParticipationSvg from './svgs/no-cost-participation.svg';
import PersonalizedSupportSvg from './svgs/personalized-support.svg';
import SkilledExpertsSvg from './svgs/skilled-experts.svg';

export const partnerLandingImages = {
  heroPrimary: HeroPrimaryImage,
  heroSecondary: HeroSecondaryImage,
  opportunity: HeroSecondaryImage,
} as const;

export const opportunityChecklist = [
  'Are solving big problems with limited time and resources',
  'Need practical, hands-on support, not just advice',
  'Benefit most from trusted expertise and strong connections',
] as const;

const stripHtml = (html?: string | null) => {
  if (!html) {
    return '';
  }

  return html
    .replace(/<br\s*\/?>/gi, ' ')
    .replace(/<\/p>/gi, ' ')
    .replace(/<[^>]+>/g, '')
    .replace(/\s+/g, ' ')
    .trim();
};

export const getPartnerHeroDescription = (partner: ImpactPartnerInfo) => {
  const cleanedDescription = stripHtml(partner.description);

  if (cleanedDescription.length > 0) {
    return cleanedDescription.length > 170 ?
        `${cleanedDescription.slice(0, 167).trim()}...`
      : cleanedDescription;
  }

  return `Available to organizations in the ${partner.name} network at no cost, through our partnership with MovingWorlds.`;
};

export const getOpportunityDescription = (partner: ImpactPartnerInfo) =>
  `You're seeing this because ${partner.name} and MovingWorlds recognize that mission-driven organizations often need timely, practical support to unlock growth.`;

export const getOpportunityIntro = (partner: ImpactPartnerInfo) =>
  `You're seeing this because ${partner.name} recognizes that social enterprises often:`;

export type GainAccessItem = {
  iconSrc: string;
  title: string;
  description: string;
};

export const getGainAccessItems = (partner: ImpactPartnerInfo): GainAccessItem[] => [
  {
    iconSrc: PersonalizedSupportSvg,
    title: 'Personalized Support',
    description:
      'Get guidance tailored to your biggest business needs, from strategy to operational challenges.',
  },
  {
    iconSrc: SkilledExpertsSvg,
    title: 'Skilled Experts',
    description:
      'Collaborate with experienced professionals from global companies like SAP, EY, Lumen, and more to develop real solutions.',
  },
  {
    iconSrc: BusinessModelStrengtheningSvg,
    title: 'Business Model Strengthening',
    description:
      'Clarify your model, refine your positioning, and build the systems needed to grow sustainably.',
  },
  {
    iconSrc: NewConnectionsOpportunitiesSvg,
    title: 'New Connections & Opportunities',
    description:
      'Tap into purpose-aligned partners, peers, and supporters that can open new doors.',
  },
  {
    iconSrc: NoCostParticipationSvg,
    title: 'No-Cost Participation',
    description: `Your access is fully sponsored by ${partner.name}.`,
  },
];
